import { getProvider } from '@/apollo'
import gql from 'graphql-tag'

const initialState = {
  step: 'simData',
  selectedSimType: 'SIM_CARD',
  simActivated: true,
  substituteSimCardOptions: [],
  skippedSelection: false
}

const SubstituteSimModule = {
  namespaced: true,
  modules: {},
  state: initialState,
  getters: {
    step: state => {
      return state.step
    },
    selectedSim: state => {
      return state.substituteSimCardOptions.find(sim => sim.type === state.selectedSimType)
    },
    substituteSimCardOptions: state => {
      return state.substituteSimCardOptions
    },
    simType: state => {
      return state.selectedSimType
    },
    simActivated: state => {
      return state.simActivated
    },
    skippedSelection: state => {
      return state.skippedSelection
    }
  },
  mutations: {
    setStep (state, step) {
      state.step = step
    },
    setSkippedSelection (state, skippedSelection) {
      state.skippedSelection = skippedSelection
    },
    setSimType (state, simType) {
      state.selectedSimType = simType
    },
    setSubstituteSimCardOptions (state, substituteSimCardOptions) {
      state.substituteSimCardOptions = substituteSimCardOptions
    },
    setSimActivated (state, simActivated) {
      state.simActivated = simActivated
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  },
  actions: {
    async orderSubstituteSim ({
      commit,
      state,
      getters,
      rootGetters
    }, payload) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation orderSubstituteSim ($substituteSimCardInput: SubstituteSimCardInput!) {
          substituteSimCard (substituteSimCardInput: $substituteSimCardInput) {
            success
          }
        }`,
        variables: {
          substituteSimCardInput: {
            substituteSimCardProcess: 'MAGMA',
            productNumber: getters.selectedSim.productNumber,
            activateByCustomer: !state.simActivated,
            // after successfully mfa, mfa token is needed to order the new sim
            ...(payload?.token && { mfaToken: payload.token })
          }
        }
      }).then((result) => {
        commit('Transaction/removeTransactionId', 'substituteSimCard', { root: true })
        return result.data.substituteSimCard.success
      }).catch((error) => {
        throw error
      })
    },
    resetState  ({ state, commit, dispatch }) {
      commit('_simData/resetState', { root: true })
      commit('_cart/resetState', { root: true })
      commit('resetState')
      return true
    }
  }
}

export default SubstituteSimModule
